import L from "leaflet";
import React from "react";
import { useMapEvents } from "react-leaflet";
import { Button, IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const ControlClasses = {
  bottomleft: "leaflet-bottom leaflet-left",
  bottomright: "leaflet-bottom leaflet-right",
  topleft: "leaflet-top leaflet-left",
  topright: "leaflet-top leaflet-right",
};

const LeafletGetCurrentLocation = ({ btnPosition, setPosition, zoom , t }) => {
  const divRef = React.useRef(null);

  React.useEffect(() => {
    if (divRef.current) {
      L.DomEvent.disableClickPropagation(divRef.current);
      L.DomEvent.disableScrollPropagation(divRef.current);
    }
  }, []);

  const map = useMapEvents({
    locationfound(e) {
      setPosition(e.latlng);
      map.flyTo(e.latlng, zoom, { animate: true });
    },
  });
// Obter minha localização atual
  const button = React.useMemo(
    () => (
      <BootstrapTooltip
        title={
          <Typography varinat="subtitle2" sx={{ p: 1 }}>
            {t("getMyCurrentLocation")}
          </Typography>
        }
        sx={{ p: 1 }}
      >
        <IconButton
          onClick={() => map.locate()}
          size="small"
          sx={{
            p: "3px",
            backgroundColor: "#fff",
            color: "black",
            borderRadius: 0,
            "&:hover": { backgroundColor: "#e9e9e9" },
          }}
        >
          <MyLocationOutlinedIcon />
        </IconButton>
      </BootstrapTooltip>
    ),
    []
  );

  return (
    <div ref={divRef} className={btnPosition && ControlClasses[btnPosition]}>
      <div
        className={"leaflet-control leaflet-bar leaflet-control-zoom"}
        style={{ left: "74px" }}
      >
        {button}
      </div>
    </div>
  );
};

export default LeafletGetCurrentLocation;
